import * as moment from 'moment';
import { Moment } from 'moment';
import * as React from 'react';
import { url } from 'src';
import { CardEvent, IEventData } from 'src/store/events/types';
import { User } from 'src/store/user/types';
import { Week } from 'src/store/weeks/types';
import {
  DateArray,
  DateTranslations,
  formatDate,
  getWeekDate,
  WeekDays
} from 'src/utils/dateHelper';
import './WeekViewPrint.scss';

interface Props {
  week: Week;
  user: User;
  events: IEventData;
}

export default class WeekViewPrint extends React.Component<Props> {
  renderEvents = (eventIds: number[], weekDate: Moment) => {
    const ev: CardEvent[] = [];
    eventIds.forEach((evId: number) => {
      const event = this.props.events.byId[evId];
      if (moment(event.begins).format('DD.MM.YYYY') === moment(weekDate).format('DD.MM.YYYY')) {
        ev.push(event);
      }
    });

    ev.sort((a: CardEvent, b: CardEvent) => {
      const aDate = new Date(a.begins);
      const bDate = new Date(b.begins);
      return aDate > bDate ? 1 : aDate < bDate ? -1 : 0;
    });

    return ev.map((event: CardEvent, i: number) => {
      return (
        <tr key={i}>
          <td>
            {formatDate(event.begins, 'hh:mm')}
            {event.title}
          </td>
        </tr>
      );
    });
  };

  renderEventsTable = (week: Week, byWeekId: { [id: number]: { [day: number]: number[] } }) => {
    let cont = false;
    const retArr: any = [];
    let counter = 0;
    do {
      const arr: any = [];
      cont = false;
      DateArray.map((dateName: string, index: number) => {
        const weekDayNum = WeekDays[dateName];
        let event;
        if (byWeekId[week.id][weekDayNum].length >= counter) {
          const id = byWeekId[week.id][weekDayNum][counter];
          event = this.props.events.byId[id];
          cont = true;
        }
        arr.push(
          <td key={index}>
            {/* <span>{DateTranslations[WeekDays[weekDayNum]]}</span> */}
            {/* <span>{getWeekDate(week.startDate, weekDayNum, 'DD.MM')}</span> */}
            {event && (
              <React.Fragment>
                <div className="big">{formatDate(event.begins, 'HH:mm')}</div>
                <div>{event.title}</div>
              </React.Fragment>
            )}
          </td>
        );
      });
      retArr.push(<tr key={counter}>{arr}</tr>);
      counter++;
    } while (cont);

    return retArr;
  };

  render() {
    const { week, user, events } = this.props;
    return (
      <div style={{ width: '100%', height: '100%', position: 'relative' }}>
        <div
          className="border bottom clearfix"
          style={{ marginBottom: '20px', paddingBottom: '10px' }}
        >
          <h1
            style={{
              fontWeight: 400,
              fontSize: '28pt',
              width: '80%',
              display: 'inline-block',
              textAlign: 'left',
              float: 'left'
            }}
          >
            Wochenprogramm,
            <br /> von {week.startDate.format('DD.MM.')} bis {week.endDate.format('DD.MM.YYYY')}
          </h1>
          <h2
            style={{
              fontWeight: 700,
              fontSize: '20pt',
              width: '80%',
              display: 'inline-block',
              textAlign: 'left',
              float: 'left'
            }}
          >
            {user.name}
          </h2>
          {user.image && <img height="50px" width="auto" src={url + user.image.url} />}
        </div>
        <div style={{ position: 'relative', width: '100%' }}>
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                {DateArray.map((dateName: string) => {
                  const weekDayNum = WeekDays[dateName];
                  return (
                    <th key={weekDayNum}>
                      <div className="big">{DateTranslations[WeekDays[weekDayNum]]}</div>
                      <div className="big">{getWeekDate(week.startDate, weekDayNum, 'DD.MM')}</div>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>{this.renderEventsTable(week, events.byWeekId)}</tbody>
          </table>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Week/WeekView/WeekViewPrint/WeekViewPrint.tsx